import c from "./lib/createApi";

// 태그
export default {
  gets: c("GET", "/v1/tag", true), // [태그 - 2] 태그 조회
  post: c("POST", "/v1/tag", true), // [태그 - 1] 태그 저장
  active: c("PUT", "/v1/tag/:id/active" , true), 
  
  // 태그 속성
  info: {
    get: c("GET", "/v1/tag/info", true), // [태그 - 7] 태그 속성 조회
    post: c("POST", "/v1/tag/:id/info", true), // [태그 - 1] 태그 저장
    // post: c("POST", "/v1/tag/info", true), // [태그 - 1] 태그 저장
    put: c("PUT", "/v1/tag/:id/info", true), // [태그 - 8] 태그 속성 수정
    delete: c("DELETE", "/v1/tag/info", true), // [태그 - 1] 태그 저장
  },

  // 태그 이름
  name: {
    post: c("POST", "/v1/tag/text", true), // [태그 - 10] 공정도내 태그 이름 변경
  },

  // 재료 형태
  shape: {
    gets: c("GET", "/v1/tag/material/shape", true), // [태그 - 4] 태그 재료의 종류 조회
    set: c("POST", "/v1/tag/material/shape", true), // [태그 - 4] 태그 재료의 종류 조회
  },

  // 템플릿
  template: {
    // /api/v1/tag/{idTag}/template
    all_gets: c( 'GET' , '/v1/tag/template' , true ) , 
    get: c( 'GET' , '/v1/tag/:id/template' , true ) , 
    update: c('PUT', '/v1/tag/:id/template',true),
    make: c('POST', '/v1/tag/:id/template',true),
    get_new : c( 'GET' , '/v1/tag/:id/template' , true ) , 
    find: c("GET", "/v1/template/tag-template", true), // [태그 - 2] 태그 조회
    paste: c("POST", "/v1/template/tag-template/:id/apply", true), // [태그 - 2] 태그 조회
  },

  //메모
  memo: {
    put: c('PUT', '/v1/tag/memo', true)
  }
};
